import { clamp } from '@resn/gozer-math';
import { deviceBenchmark } from 'utils/device-benchmark';
import { isMobile } from '@resn/gozer-env';

export default () => {
    const max = isMobile || deviceBenchmark.tier === 3 ? 2 : 1.5;
    return clamp(window.devicePixelRatio, 1, max);
};
